// extracted by mini-css-extract-plugin
module.exports = {"text":"Content_text__1FPfC","rectangle":"Content_rectangle__3f6pX","modalContent":"Content_modalContent__SOHaT"};